import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, coreTheme, TouchableOpacity } from "@kolmeo/ui-core";
import Icon from "../Icon";
const CheckBox = ({ status, disabled, onPress }) => {
    return (_jsxs(Box, { opacity: disabled ? 0.3 : 1, accessibilityRole: "checkbox", accessibilityState: {
            checked: status,
        }, flexDirection: "row", children: [_jsx(TouchableOpacity, { onPress: () => onPress(true), children: _jsx(Icon, { type: "check", size: "sm", color: status === true ? coreTheme.palette.success : coreTheme.palette.kitti }) }), _jsx(TouchableOpacity, { ml: "22px", onPress: () => onPress(false), children: _jsx(Icon, { type: "close", size: "sm", color: status === false ? coreTheme.palette.danger : coreTheme.palette.kitti }) })] }));
};
export default CheckBox;
